import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const btn = document.createElement("button");
    btn.innerHTML = `
    <svg id="show" class="inline-block w-6 h-6 stroke-current fill-transparent"><use xlink:href="/assets/images/sprite.svg#icon-show"/></svg>
    <svg id="hide" class="hidden w-6 h-6 stroke-current fill-transparent"><use xlink:href="/assets/images/sprite.svg#icon-hide"/></svg>
    `;
    btn.classList.add(
      "absolute",
      "right-6",
      "top-1/2",
      "-translate-y-1/2",
      "bg-white",
    );
    btn.setAttribute("data-action", "click->userShowPassword#toggle:prevent");
    this.element.append(btn);
  }

  submitForm() {
    const form = this.element.closest("form");
    const submitBtn = form.querySelector("button[data-submit]");
    submitBtn.focus();
    submitBtn.click();
  }

  toggle() {
    const input = this.element.querySelector("input");
    input.setAttribute(
      "type",
      input.getAttribute("type") === "password" ? "text" : "password",
    );
    const icons = this.element.querySelectorAll("button > svg");
    icons.forEach((icon) => {
      icon.classList.toggle("inline-block");
      icon.classList.toggle("hidden");
    });
  }
}
